<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useI18n } from "vue-i18n"

// ================================
// PROPS & EMITS
// ================================

const props = defineProps<{
    /** True si titulaire particulier (sans société) */
    customer: boolean
}>()

const emit = defineEmits<{
    click: []
}>()

// ================================
// I18N
// ================================

const { t } = useI18n({
    messages: {
        fr: {
            explain_title: "Comment ça marche ?",
            step_dda: "Formulation de Déclaration de Droit d’Accès (DDA)",
            step_sign: "Signature du consentement",
            step_grdf: "Déclaration au près de GRDF",
            start: "Commencer",
            last_pro:
                "Enfin, nous enverrons une demande d'accès à GRDF, et si aucune objection n'est reçue dans les 2 jours par le titulaire du compteur, les droits seront activés automatiquement. Vous êtes pressés ? Activez la collecte de données en cliquant sur le lien présent dans l'e-mail de confirmation reçu par GRDF.",
            last_customer:
                "Enfin, nous enverrons une demande d'accès à GRDF, vous avez ensuite 3 jours pour activer la collecte de données en cliquant sur le lien présent dans l'e-mail de confirmation reçu par GRDF.",
            bullet1:
                "Vérifiez et mettez à jour les informations liés à votre déclaration d'accès au donnée, notamment le code postal et la date d'ouverture du contrat avec le fournisseur.",
            bullet2:
                "Signez ensuite le consentement pour autoriser Homeys à collecter les données du compteur de gaz.",
        },
    },
})

// ================================
// COMPUTED
// ================================

const getSteps = computed(() => [
    { label: t("step_dda"), status: "pending" as const },
    { label: t("step_sign"), status: "pending" as const },
    { label: t("step_grdf"), status: "pending" as const },
])

const explainBullets = computed(() => [
    t("bullet1"),
    t("bullet2"),
    props.customer ? t("last_customer") : t("last_pro"),
])
</script>

<template>
    <div class="flex flex-col items-center gap-8 w-full max-w-xl mx-auto">
        <div class="flex flex-col gap-4 text-left w-full">
            <p class="font-semibold text-gray-800">
                {{ t("explain_title") }}
            </p>
            <ul class="list-disc pl-5 text-sm text-gray-700 space-y-2">
                <li v-for="(line, i) in explainBullets" :key="i">
                    {{ line }}
                </li>
            </ul>
        </div>
        <ul
            class="w-full text-sm text-gray-600 space-y-2 border border-gray-200 rounded-lg p-4"
        >
            <li v-for="(s, i) in getSteps" :key="i" class="flex gap-2">
                <span class="font-medium text-gray-800">{{ i + 1 }}.</span>
                <span>{{ s.label }}</span>
            </li>
        </ul>
        <BaseButton
            :label="t('start')"
            class="min-w-[12rem]"
            @click="emit('click')"
        />
    </div>
</template>
